import { createRouter, createWebHashHistory } from "vue-router";

import { appRoutes } from "./routes.app";
import { isAnonymousAccess } from "./route-access";
import store from "@/root/store/store";
import { authService } from "@/common/services/auth-service";
import { projectEntity } from "@/common/model/project/project-entity";
import { canUseProjectListSessionCache } from "@/project/project-list-state";

const router = createRouter({
  history: createWebHashHistory(),
  routes: appRoutes,
});

router.beforeEach((to) => {
  if (to.matched.length === 0) {
    return authService.isAuthenticated()
      ? { name: "TicketCreateComponent" }
      : { name: "Login" };
  }

  if (authService.isAuthenticated() && to.name === "Login") {
    return { name: "TicketCreateComponent" };
  }

  if (!authService.isAuthenticated() && !isAnonymousAccess(to)) {
    return { name: "Login" };
  }

  // Permission gates live here (not in sidebar rendering) so deep links can't bypass access.
  const initialized = store.getters["ContactModule/getIsStateInitialized"];

  if (to.name === "AssetSummary") {
    if (initialized) {
      const allowed = store.getters["ContactModule/getHasAllAssetsTag"];
      if (!allowed) {
        return { name: "TicketCreateComponent" };
      }
    }
  }

  if (to.name === "InvoiceList") {
    if (initialized) {
      const allowed = store.getters["ContactModule/getHasAllInvoicesTag"];
      if (!allowed) {
        return { name: "TicketCreateComponent" };
      }
    }
  }

  if (to.name === "TicketSummary") {
    if (initialized) {
      const allowed = store.getters["ContactModule/getHasAllTicketsTag"];
      if (!allowed) {
        return { name: "TicketCreateComponent" };
      }
    }
  }

  if (to.name === "ProjectList") {
    if (initialized) {
      if (canUseProjectListSessionCache() && projectEntity.count() === 0) {
        return { name: "TicketCreateComponent" };
      }
    }
  }

  return true;
});

export default router;
